import React from 'react'
import LandingPage from '../../component/Layout/DataContract/LandingPage'

const DataContract = () => {
  return (
    <div>
        <LandingPage/>
  </div>
  )
}
      
export default DataContract
